<script>
import TimelineActionBar from 'vcomponents/timeline/timelineActionBar/TimelineActionBar.vue';
import moment from 'moment';
export default {
    name: 'TimelineActionBarEvent',
    extends: TimelineActionBar,
    computed: {
        // eslint-disable-next-line vue/no-unused-properties
        canDelete() {
            return this.oneLog.can_edit;
        },
        // eslint-disable-next-line vue/no-unused-properties
        canEdit() {
            return this.oneLog.can_edit;
        },
    },
    methods: {
        previewElement(onelog) {
            if (this.isNewPanelEnabled) {
                this.openDetail('event');
            } else {
                Agenda.preview(
                    onelog.editableid,
                    onelog.calendar,
                    '',
                    moment(onelog.start, 'X').tz(this.timezone).format('YYYY-MM-DD HH:mm:ss'),
                    moment(onelog.end, 'X').tz(this.timezone).format('YYYY-MM-DD HH:mm:ss'),
                    onelog.isRecurring,
                    onelog.title,
                    onelog.can_edit,
                );
            }
        },
        editElement(onelog) {
            Activities.openActivityForm(
                onelog.editableid,
                null,
                null,
                null,
                'event',
                onelog.calendar,
            );
        },
        deleteElement(onelog) {
            if (onelog.isRecurring)
                Agenda.checkDeleteRecurring(onelog.editableid, onelog.calendar, onelog.objecttype);
            else
                Agenda.deleteAlert(
                    onelog.editableid,
                    onelog.calendar,
                    false,
                    'N',
                    onelog.objecttype,
                    '',
                    '',
                    onelog.title,
                );
        },
    },
};
</script>
